import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionsPanel = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'buy',
      label: 'Buy Stock',
      icon: 'Plus',
      color: 'success',
      description: 'Add new positions to your portfolio',
      onClick: () => navigate('/stock-search-discovery')
    },
    {
      id: 'sell',
      label: 'Sell Stock',
      icon: 'Minus',
      color: 'warning',
      description: 'Reduce or close existing positions',
      onClick: () => navigate('/portfolio-management')
    },
    {
      id: 'watchlist',
      label: 'View Watchlist',
      icon: 'Eye',
      color: 'secondary',
      description: 'Monitor your tracked stocks',
      onClick: () => handleViewWatchlist()
    },
    {
      id: 'reports',
      label: 'Portfolio Reports',
      icon: 'FileText',
      color: 'primary',
      description: 'Generate detailed performance reports',
      onClick: () => handleGenerateReport()
    }
  ];

  const handleViewWatchlist = () => {
    const watchlist = JSON.parse(localStorage.getItem('stockWatchlist') || '[]');
    if (watchlist.length === 0) {
      alert('Your watchlist is empty. Add stocks from the Stock Search & Discovery page.');
    } else {
      navigate('/stock-search-discovery');
    }
  };

  const handleGenerateReport = () => {
    // Simulate report generation
    alert('Portfolio report generation feature would be implemented here. This would include performance metrics, allocation analysis, and recommendations.');
  };

  const handleToggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="card-elevated p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-accent/10 rounded-lg">
            <Icon name="Zap" size={20} className="text-accent" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
            <p className="text-sm text-muted-foreground">Fast access to key features</p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={handleToggleExpanded}
          iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
        >
          {isExpanded ? 'Less' : 'More'}
        </Button>
      </div>

      <div className="space-y-3">
        {quickActions.slice(0, isExpanded ? quickActions.length : 2).map((action) => (
          <Button
            key={action.id}
            variant="outline"
            size="lg"
            fullWidth
            onClick={action.onClick}
            className="flex items-center justify-start space-x-3 h-auto p-4"
          >
            <div className={`p-2 rounded-lg bg-${action.color}/10`}>
              <Icon name={action.icon} size={20} className={`text-${action.color}`} />
            </div>
            <div className="flex-1 text-left">
              <div className="text-sm font-medium text-foreground">
                {action.label}
              </div>
              <div className="text-xs text-muted-foreground">
                {action.description}
              </div>
            </div>
            <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
          </Button>
        ))}
      </div>

      {!isExpanded && (
        <div className="mt-4 pt-4 border-t border-border">
          <Button
            variant="ghost"
            size="sm"
            fullWidth
            onClick={handleToggleExpanded}
            className="text-muted-foreground hover:text-foreground"
          >
            <Icon name="MoreHorizontal" size={16} className="mr-2" />
            View {quickActions.length - 2} more actions
          </Button>
        </div>
      )}
    </div>
  );
};

export default QuickActionsPanel;